import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93ce90a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-list-page" }
const _hoisted_2 = { class: "data" }
const _hoisted_3 = { class: "ws_common_operation" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["onClick"]

import { onMounted, ref, watch, computed } from 'vue'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import {
  PAGE_SIZES,
  DEVICE_STATUS_ENUM,
  CODE_ENUM,
  CONNECT_TYPE,
} from '@/common'
import TransferModal from './components/transfer.vue'
import DeviceCommand from './components/device-command.vue'
import { useRouter } from 'vue-router'
import {
  queryDevicePage,
  deleteDeviceInfo,
  deviceMethodOnlinecheck,
} from '@/api'
import { ElMessageBox } from 'element-plus'
import SelectDevice from '@/components/select-device'
import Selecttenant from '@/components/select-tenant'
import OperationButtonList from '@/components/operation-button-list'
import { msgbox } from '@/utils'
import { useProductStore } from '@/stores/product'
import { useTenantStore } from '@/stores/tenant'
import moment from 'moment'
import { ElMessage } from 'element-plus'
import BatchDevice from './components/batch-device.vue'
import { formatFormTime } from '@/utils'
import BatchUpdate from './components/batch-update.vue'
import BatchUpdateNo from './components/batch-update-no.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

const deviceStatusOps = [
  {
    label: '未激活',
    value: DEVICE_STATUS_ENUM.NOACTIVATE,
  },
  // {
  //   label: '已激活',
  //   value: DEVICE_STATUS_ENUM.INACTIVATE,
  // },
  {
    label: '离线',
    value: DEVICE_STATUS_ENUM.OFFLINE,
  },
  {
    label: '在线',
    value: DEVICE_STATUS_ENUM.ONLINE,
  },
]

const connectTypeOps = [
  {
    label: '4G',
    value: CONNECT_TYPE['4G'],
  },
  {
    label: 'LEO',
    value: CONNECT_TYPE.LEO,
  },
  {
    label: 'GEO',
    value: CONNECT_TYPE.GEO,
  },
  {
    label: 'Lora',
    value: CONNECT_TYPE.LORA,
  },
]

const productStrore = useProductStore()
productStrore.queryGetewayType()

const tenantStore = useTenantStore()

const getButtonList = (row: any) => {
  const disabled = tenantStore.topOrgId !== row.topOrgId
  return [
    {
      type: 'edit',
      text: '编辑',
    },
    {
      type: 'delete',
      text: '删除',
      disabled,
    },
    {
      type: 'detail',
      text: '详情',
    },
    // {
    //   type: 'warning',
    //   text: '告警记录',
    // },
  ]
}

const transferDisabled = computed(() => {
  const orgIds = [
    ...new Set(multipleSelection.value.map((item: any) => item.topOrgId)),
  ]
  return !(orgIds.length === 1 && orgIds[0] === tenantStore.topOrgId)
})

const updateDisabled = computed(() => {
  return (
    multipleSelection.value.length === 0 ||
    !multipleSelection.value.every((item: any) => {
      return item.sgFlag
    })
  )
})

const advancedRef = ref()

const router = useRouter()

const tableData: any = ref([])
const formInline = ref({
  keyWords:'',
  orgId: undefined,
  deviceId: undefined,
  deviceSn: '',
  productKey: '',
  deviceStatusCode: '',
  deviceNo: '',
  connectTypes: [],
  createTime: [],
})

const getMoTime = (keepAliveData: any) => {
  return {
    ...formatFormTime(keepAliveData.createTime, ['tleStartTime', 'tleEndTime']),
  }
}

const deviceStatusMap = {
  [DEVICE_STATUS_ENUM.ONLINE]: 'success',
  [DEVICE_STATUS_ENUM.INACTIVATE]: '',
  [DEVICE_STATUS_ENUM.OFFLINE]: 'info',
  [DEVICE_STATUS_ENUM.NOACTIVATE]: 'warning',
}
const getDeviceTagType = (status: any) => {
  return deviceStatusMap[status]
}

onMounted(async () => {
  await tenantStore.queryTopOrg()
  fetchList()
})

// 租户改变，清除
const orgChange = () => {
  formInline.value = {
    ...formInline.value,
    deviceId: undefined,
  }
}

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const rowClassName = ({ row }: any) => {
  return row.subDeviceFlag ? '' : 'hiden-expand'
}

const col: any = [
  {
    prop: 'deviceName',
    label: '设备名称',
  },
  {
    prop: 'deviceSn',
    label: '设备SN',
  },
  {
    prop: 'imei',
    label: 'IMEI',
  },
  {
    prop: 'topOrgName',
    label: '所属租户',
  },
  {
    prop: 'productTypeValue',
    label: '所属产品',
  },
  // {
  //   prop: 'deviceAddress',
  //   label: '设备地址',
  //   formatter: ({ deviceLocationInfo }: any) => {
  //     return deviceLocationInfo?.deviceAddress || '-'
  //   },
  // },
  {
    prop: 'connectType',
    label: '接入方式',
  },
]

const subCol = ref([
  {
    prop: 'deviceName',
    label: '子设备名称',
  },
  {
    prop: 'producer',
    label: '厂家',
  },
  {
    prop: '',
    label: '品牌/型号',
    formatter: ({ brand, productModel }: any) => {
      return [brand, productModel].filter(Boolean).join('/')
    },
  },
  {
    prop: 'deviceSn',
    label: '端口号/SN',
  },
  {
    prop: 'variable',
    label: '变量',
  },
])
const tableLoading = ref(false)

const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData() || {}
  const { data, reset } = queryData || {}
  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  const moTime = getMoTime(keepAliveData)
  tableLoading.value = true
  const res: any = await queryDevicePage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
    ...moTime,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === 0) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

const multipleSelection: any = ref([])
const handleSelectionChange = (val: any) => {
  multipleSelection.value = val
}

const toDelete = ({ id }: any) => {
  msgbox({
    tip: '删除设备将删除关联的配置关系，但不影响此设备关联的数据，请确认是否删除？',
    thenFn: () => toDeleteDevice({ id }),
  })
}

const toDeleteDevice = async ({ id }: any) => {
  const res: any = await deleteDeviceInfo({
    deviceBindIds: [id],
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    fetchList()
  }
}

const toEditDevice = ({ id }: any) => {
  router.push({
    name: 'device-detail',
    query: {
      deviceBindId: id,
    },
  })
}

const toAddDevice = () => {
  router.push({
    name: 'device-detail',
  })
}

const toView = ({ deviceId }: any) => {
  router.push({
    name: 'device-data',
    query: {
      deviceId,
    },
  })
}

const toWarning = ({ deviceId, topOrgId }: any) => {
  router.push({
    name: 'alarm-list',
    query: {
      deviceId,
      orgId: topOrgId,
    },
  })
}

const deviceCheck = async (deviceId: string) => {
  const res: any = await deviceMethodOnlinecheck({
    deviceId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessageBox.alert('采集指令已经下发', '提示', {
      autofocus: false,
      confirmButtonText: '确定',
      callback: () => {},
    })
  }
}

const transferConf = ref({
  visible: false,
})
const toTransfer = () => {
  transferConf.value = {
    visible: true,
  }
}

const deviceConf = ref({
  visible: false,
})
const toDeviceConf = () => {
  deviceConf.value = {
    visible: true,
  }
}

const batchDeviceConf = ref({
  visible: false,
})
const handleBatchDeviceConf = () => {
  batchDeviceConf.value = {
    visible: true,
  }
}

const deviceUpdateConf = ref({
  visible: false,
})
const toDeviceUpdateConf = () => {
  deviceUpdateConf.value = {
    visible: true,
  }
}

const deviceUpdateNoConf = ref({
  visible: false,
})
const toDeviceUpdateNoConf = () => {
  deviceUpdateNoConf.value = {
    visible: true,
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(AdvancedQueryLayout), {
        class: "advance-container",
        ref_key: "advancedRef",
        ref: advancedRef,
        model: formInline.value,
        onFetchList: fetchList,
        "label-width": 112
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "租户",
            prop: "orgId"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Selecttenant), {
                "show-type": true,
                modelValue: formInline.value.orgId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.orgId) = $event)),
                onChange: orgChange
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "设备名称",
            prop: "deviceId"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SelectDevice), {
                modelValue: formInline.value.deviceId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.deviceId) = $event)),
                orgId: formInline.value.orgId
              }, null, 8, ["modelValue", "orgId"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "关键词",
            prop: "keyWords"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.keyWords,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formInline.value.keyWords) = $event)),
                clearable: "",
                maxlength: "50",
                class: "ws_select"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "设备SN",
            prop: "deviceSn"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.deviceSn,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formInline.value.deviceSn) = $event)),
                clearable: "",
                maxlength: "50",
                class: "ws_select"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "所属产品",
            prop: "productKey"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formInline.value.productKey,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formInline.value.productKey) = $event)),
                clearable: "",
                class: "ws_select"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStrore).productGetewayType, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.code,
                      label: item.name,
                      value: item.code
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "接入方式",
            prop: "connectTypes"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formInline.value.connectTypes,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formInline.value.connectTypes) = $event)),
                clearable: "",
                class: "ws_select",
                multiple: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(connectTypeOps, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "状态",
            prop: "deviceStatusCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formInline.value.deviceStatusCode,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formInline.value.deviceStatusCode) = $event)),
                clearable: "",
                class: "ws_select"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(deviceStatusOps, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "星历更新时间",
            prop: "createTime",
            class: "ws_time_range create-time"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: formInline.value.createTime,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formInline.value.createTime) = $event)),
                "unlink-panels": "",
                type: "datetimerange",
                "range-separator": "-",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                editable: false,
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            disabled: updateDisabled.value,
            onClick: toDeviceUpdateConf,
            class: "ws_mr16",
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("批量升级")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            onClick: toDeviceUpdateNoConf,
            class: "ws_mr16",
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("升级历史")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            disabled: transferDisabled.value,
            onClick: toTransfer,
            class: "ws_mr16",
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("批量流转")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            onClick: handleBatchDeviceConf,
            class: "ws_mr16",
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("批量添加设备")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: toAddDevice,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("添加设备")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            class: "ws_common_table ws_mt20",
            data: tableData.value,
            onSelectionChange: handleSelectionChange,
            "row-class-name": rowClassName
          }, {
            empty: _withCtx(() => [
              _createVNode(_component_el_empty, { description: "暂无数据" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                width: "55"
              }),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item, index) => {
                return _createVNode(_component_el_table_column, {
                  key: index,
                  prop: item.prop,
                  label: item.label,
                  formatter: item.formatter,
                  "show-overflow-tooltip": ""
                }, null, 8, ["prop", "label", "formatter"])
              }), 64)),
              _createVNode(_component_el_table_column, {
                width: "130",
                prop: "dcsStatusValue",
                label: "DCS状态"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.dcsStatusCode !== _unref(DEVICE_STATUS_ENUM).NONE)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        class: "ml-2",
                        type: getDeviceTagType(scope.row.dcsStatusCode)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.dcsStatusValue), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                width: "150",
                prop: "deviceStatusName",
                label: "设备状态"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_tag, {
                    class: "ml-2",
                    type: getDeviceTagType(scope.row.deviceStatusCode)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.deviceStatusName), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"]),
                  (
                scope.row.deviceStatusCode === _unref(DEVICE_STATUS_ENUM).OFFLINE &&
                scope.row.supportOnlineMethod
              )
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: ($event: any) => (deviceCheck(scope.row.deviceId)),
                        class: "ws_ml15 online-check"
                      }, "在线检测", 8, _hoisted_6))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "tleLastTime",
                label: "星历更新时间",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.tleLastTime
                ? _unref(moment)(scope.row.tleLastTime).format('YYYY-MM-DD HH:mm:ss')
                : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                width: 300,
                label: "操作"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_unref(OperationButtonList), {
                    scope: scope.row,
                    buttonList: getButtonList(scope.row),
                    onOnDetail: toView,
                    onOnDelete: toDelete,
                    onOnEdit: toEditDevice,
                    onOnWarning: toWarning
                  }, null, 8, ["scope", "buttonList"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, tableLoading.value]
          ]),
          _createVNode(_component_el_pagination, {
            class: "ws_mt50",
            "current-page": pageParams.value.curPage,
            "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => ((pageParams.value.curPage) = $event)),
            "page-size": pageParams.value.pageSize,
            "onUpdate:pageSize": _cache[9] || (_cache[9] = ($event: any) => ((pageParams.value.pageSize) = $event)),
            "page-sizes": _unref(PAGE_SIZES),
            layout: "->, total, sizes, prev, pager, next, jumper ",
            total: total.value,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
        ])
      ])
    ]),
    _createVNode(TransferModal, {
      visible: transferConf.value.visible,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((transferConf.value.visible) = $event)),
      data: multipleSelection.value,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"]),
    _createVNode(DeviceCommand, {
      visible: deviceConf.value.visible,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((deviceConf.value.visible) = $event))
    }, null, 8, ["visible"]),
    _createVNode(BatchUpdate, {
      visible: deviceUpdateConf.value.visible,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((deviceUpdateConf.value.visible) = $event)),
      data: multipleSelection.value,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"]),
    _createVNode(BatchUpdateNo, {
      visible: deviceUpdateNoConf.value.visible,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((deviceUpdateNoConf.value.visible) = $event))
    }, null, 8, ["visible"]),
    _createVNode(BatchDevice, {
      visible: batchDeviceConf.value.visible,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((batchDeviceConf.value.visible) = $event)),
      onSuccess: fetchList
    }, null, 8, ["visible"])
  ], 64))
}
}

})